"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestAsyncRenderHandler = void 0;
var render_1 = require("../../events/render");
function requestAsyncRenderHandler(ctx, cmd) {
    var id = cmd.payload.id, correlationId = cmd.correlationId;
    return render_1.asyncRenderRequested(id, ctx, correlationId);
}
exports.requestAsyncRenderHandler = requestAsyncRenderHandler;
//# sourceMappingURL=requestAsyncRenderHandler.js.map